import { tProvidersProps } from '../../../../../providers/LayoutProvider/Layout.types.ts';
import { MetaConnectionModalContext } from './MetaConnectionModal.constants.ts';
import useMetaConnectionModal from './MetaConnectionModal.hook.ts';

export default function MetaConnectionModalProvider(props: tProvidersProps) {
  const { children } = props;
  const metaConnectionModal = useMetaConnectionModal();
  return (
    <MetaConnectionModalContext.Provider value={metaConnectionModal}>
      {children}
    </MetaConnectionModalContext.Provider>
  );
}
